const componentLoads = {
  Invoice: () => import('./document/Invoice'),
  CustomerOpenBalances: () => import('./document/CustomerOpenBalances'),
  PastDueInvoices: () => import('./document/PastDueInvoices'),
  OrderSummary: () => import('./document/OrderSummary'),
  CustomerRateConfirmation: () => import('./document/CustomerRateConfirmation'),

  BillOfLading: () => import('./document/BillOfLading'),
  CarrierRateConfirmation: () => import('./document/CarrierRateConfirmation'),

  CarrierOpenBalances: () => import('./document/CarrierOpenBalances'),
};

type DocumentName = keyof typeof componentLoads;
const documentNames = Object.keys(componentLoads) as DocumentName[];

export const documentRoutes = documentNames.map((name) => ({
  path: `/document/${name}/:id`,
  load: componentLoads[name],
  hideLayout: true,
}));
